import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as ramda from 'ramda';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import logValueOnChange from '../commonActions/logValueOnChange';
import { UncomposedOptionPickerField } from './optionPickerField';
import localChangeSelector from '../selectors/localChangeSelector';
const prepareOptions = list => {
  const result = list.map(item => ({
    identifier: item.id,
    title: item.name
  }));
  return result;
};
const ComponentCodePicker = ({
  enabled,
  issueComponentCode: {
    indexQuery,
    list
  },
  issueComponentCodeActions: {
    serverFilter
  },
  label,
  onChange,
  path,
  value: _value = '',
  localChangeFunc,
  active: _active = {}
}) => {
  const jobLens = ramda.lensPath(['active', 'report', 'jobID']);
  const activeJobID = ramda.view(jobLens, {
    active: _active
  });
  useEffect(() => {
    serverFilter({
      job: [activeJobID]
    }, indexQuery);
  }, [indexQuery, activeJobID, serverFilter]);
  return /*#__PURE__*/React.createElement(UncomposedOptionPickerField, {
    className: "t-ccp",
    enabled: enabled,
    label: label,
    path: path,
    placeholder: "Select Component Code",
    onChange: args => onChange(localChangeFunc(args)),
    options: prepareOptions(list),
    value: _value
  });
};
ComponentCodePicker.propTypes = {
  enabled: PropTypes.bool.isRequired,
  issueComponentCode: PropTypes.shape({
    indexQuery: PropTypes.shape({}).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  issueComponentCodeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  localChangeFunc: PropTypes.func.isRequired,
  active: PropTypes.shape({})
};
export { ComponentCodePicker as UncomposedComponentCodePicker };
export default entityComposition(ComponentCodePicker, ['issueComponentCode'], {
  active: state => state.issue.active,
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  localChangeFunc: localChangeSelector
});